import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import DropdownAccordion from './DropdownAccordion';
import ModalTrigger from './ModalTrigger';
import Avatar from './Avatar';

class CustomDropdown extends Component {
  static propTypes = {
    name: PropTypes.string,
    renderTrigger: PropTypes.func,
    renderItem: PropTypes.func,
    renderCarret: PropTypes.bool,
    className: PropTypes.string,
    currentItemText: PropTypes.string,
    contentClassName: PropTypes.string,
    carretClassName: PropTypes.string,
    listClassName: PropTypes.string,
    triggerClassName: PropTypes.string,
    items: PropTypes.array.isRequired,
    emptyItemsListPlaceholder: PropTypes.string,
    asyncCallback: PropTypes.func,
    addMarginTop: PropTypes.bool,
    active: PropTypes.bool,
    inModal: PropTypes.bool,
  };

  static defaultProps = {
    name: '',
    renderTrigger: null,
    renderItem: null,
    renderCarret: false,
    className: null,
    contentClassName: 'u-left-0',
    listClassName: '',
    carretClassName: 'u-ml-2',
    triggerClassName: 'dropdown-trigger',
    currentItemText: '',
    emptyItemsListPlaceholder: 'There are no items available',
    asyncCallback: () => {},
    addMarginTop: true,
    active: false,
    inModal: false,
  };

  constructor(props) {
    super(props)

    this.dropdown = React.createRef();
    this.state = {
      open: false
    }
  }

  onShow = () => {
    this.setState({ open: true });
  }

  onHide = () => {
    this.setState({ open: false });
  }

  hide = () => {
    this.dropdown.current.hide();
  }

  handleAsyncClick = (item) => {
    this.props.asyncCallback(item);
    this.dropdown.current.hide();
  };

  renderTrigger = () => {
    if (this.props.renderTrigger) {
      return this.props.renderTrigger();
    } if (this.props.active) {
      return (<button className="u-w-full u-truncate u-text-left">
        <span className="u-font-normal u-mr-2">{this.props.name}</span>
        <span className="u-font-semibold">{this.props.currentItemText}</span>
      </button>);
    }
    return this.props.currentItemText;
  };

  renderItem = item => {
    const { text, type, href, items, async, 'data-modal': dataModal, 'data-action': dataAction, ...otherProps } = item;
    let { key } = item;
    key = key || item.id;

    if (type === 'divider') {
      return <li key={key} className="dropdown-divider" />;
    } else if (type === 'avatar') {
      return (
        <li key={key} className="u-p-4 u-flex u-items-center">
          <Avatar src={href} name={text} className="u-w-9 u-h-9 u-mr-4" />
          <span className="u-font-semibold u-text-2xl">{text}</span>
        </li>
      );
    } else if (type === 'title') {
      return (
        <li key={key} className="dropdown-title">
          { item.icon !== undefined &&
            <i className={`${item.icon} u-flex u-items-center u-mr-2`} />
          }
          {text}
        </li>
      );
    } else if (type === 'list') {
      return (
        <li key={key}>
          <DropdownAccordion
            collection={items}
            title={text}
            titleClass="dropdown-accordion-trigger dropdown-item u-flex u-items-center u-justify-between"
            listClass="dropdown-accordion-content u-border-t u-border-grey-lighter u-m-0"
            listItemClass="dropdown-accordion-item u-flex u-items-center"
          />
        </li>
      );
    } else if (type === 'event') {
      return (
        <li key={key} className="dropdown-title">
          { item.icon !== undefined &&
            <i className={`${item.icon} u-flex u-items-center u-mr-2`} />
          }
          {text}
        </li>
      );
    } else if (dataModal) {
      if (this.props.inModal && async) { // If dropdown is inside modal
        return (
          <li key={key} className="dropdown-item u-flex u-flex-col u-items-center u-cursor-pointer">
            <a href={href} className="u-flex u-w-full u-items-center dropdown-item--modal-trigger" data-remote="true">
              <i className={`${item.icon} u-mr-2`} />{text}
            </a>
          </li>
        );
      } else {
        return (
          <li key={key} className="dropdown-item u-flex u-flex-col u-items-center u-cursor-pointer">
            <ModalTrigger
              async={async}
              triggerLabel={text}
              triggerIcon={item.icon}
              triggerClassName="u-flex u-w-full u-items-center dropdown-item--modal-trigger"
              triggerIconClassName="u-mr-2"
              data-action={dataAction}
              asyncUrl={href}>
            </ModalTrigger>
          </li>
        );
      }
    } else if (async) {
      return (
        <li key={key} className="dropdown-item u-flex u-items-center u-cursor-pointer" onClick={() => this.handleAsyncClick(item)}>
          { item.icon !== undefined &&
            <i className={`${item.icon} u-flex u-items-center u-mr-2`} />
          }
          {text}
        </li>
      );
    } else if (this.props.renderItem) {
      return <li key={key}>{this.props.renderItem(item)}</li>;
    }

    return (
      <li key={key} className="dropdown-item">
        <a href={href} className="u-flex u-items-center" {...otherProps}>
          { item.icon !== undefined &&
            <i className={`${item.icon} u-flex u-items-center u-mr-2`} />
          }
          {text}
        </a>
      </li>
    );
  };

  render() {

    const backshadowClasses = ['u-fixed u-bg-black u-w-full u-h-full u-inset-0 u-opacity-30 lg:u-hidden'];
    if (this.state.open) {
      backshadowClasses.push("u-block");
    } else {
      backshadowClasses.push("u-hidden");
    }

    return (
      <Dropdown
        className={this.props.className ? this.props.className : 'u-relative'}
        ref={this.dropdown} onShow={this.onShow} onHide={this.onHide}
      >
        <DropdownTrigger className={`${this.props.triggerClassName} ${this.props.active ? 'is-active' : ''}`}>
          {this.renderTrigger()}
          { this.props.renderCarret && (
            <i className={`Icon Icon-caret-down u-text-grey-light ${this.props.carretClassName}`} />
          )}
        </DropdownTrigger>
        <div className={backshadowClasses.join(" ")} onClick={this.hide}></div>
        <DropdownContent
          className={`dropdown-content ${this.props.contentClassName}`}
          style={this.props.addMarginTop ? { marginTop: '3rem' } : {}}>
          <ul className={`u-m-0 ${this.props.listClassName}`}>
            { this.props.items.length === 0 && (
              <li>{this.props.emptyItemsListPlaceholder}</li>
            ) }
            { this.props.items.length > 0 && this.props.items.map(this.renderItem)}
          </ul>
        </DropdownContent>
      </Dropdown>
    );
  }
}

export default CustomDropdown;
